import { useQuery } from "@tanstack/react-query";

import useCurrentOrganization from "~/lib/organizations/hooks/use-current-organization";
import { getOrgTeamMembers } from "~/lib/organizations/queries";

import { REACT_QUERY_KEY } from "../constants/common";

export const useOrgMembersData = (enabled?: boolean) => {
  const org = useCurrentOrganization();

  const {
    isLoading: loadingOrgMembers,
    data: teamMembers,
    refetch: refetchOrgTeamMembersData,
  } = useQuery({
    queryKey: [REACT_QUERY_KEY.ORG_TEAM_MEMBERS, org?.org_id],
    queryFn: async ({ queryKey }) => getOrgTeamMembers(queryKey[1] as string),
    enabled: enabled === undefined ? !!org : !!org && enabled,
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return { loadingOrgMembers, teamMembers, refetchOrgTeamMembersData };
};
